import Vue from 'vue'
import Router from 'vue-router'
import home from './home.js'
import staticModal from './staticModal'


const index = (resolve) => require(['@/views/index.vue'], resolve)
const guide = (resolve) => require(['@/views/guide.vue'], resolve)

Vue.use(Router)

export default new Router({
  mode:'history',
  base:'/studypage',
  routes: [
    {
      path: '/',
      name: 'index',
      redirect:'/exportApp',
      component: index,
      meta: {
        title: ''
      },
      children: [
        {
          path: 'guide',
          name: 'guide',
          component: (resolve) => require(['@/views/guide'], resolve),//ios下载指引
          meta:{
              title:''
          }
        }, 
        {
          path: 'manhanttanApp',
          name: 'manhanttanApp',
          component: (resolve) => require(['@/views/manhanttanApp'], resolve),//曼哈顿下载页
          meta:{
              title:''
          }
        }, 
        {
          path: 'manIOSGuide',
          name: 'manIOSGuide',
          component: (resolve) => require(['@/views/manIOSGuide'], resolve),//曼哈顿IOS下载指引页
          meta:{
              title:''
          }
        }, 
        ...home,
        ...staticModal,
        {
          path: 'crmPrivate',
          name: 'crmPrivate',
          component: (resolve) => require(['@/views/crmPrivate'], resolve),//ios下载指引
          meta:{
              title:''
          }
        }, 
        {
          path: 'crmAgreement',
          name: 'crmAgreement',
          component: (resolve) => require(['@/views/crmAgreement'], resolve),//ios下载指引
          meta:{
              title:''
          }
        }, 
        {
          path: 'notFound',
          name: 'notFound',
          component: (resolve) => require(['@/views/404.vue'], resolve),
          meta: {
            title: '错误页面'
          }
        },
        {
          path: 'test',
          name: 'test',
          component: (resolve) => require(['@/views/test.vue'], resolve),
          meta: {
            title: ''
          }
        },
        {
          path: 'campusCulture',
          name: 'campusCulture',
          component: (resolve) => require(['@/views/publicity/campus'], resolve),//校园文化
          meta:{
              title:''
          }
      }, 
      {
          path: 'teachingService',
          name: 'teachingService',
          component: (resolve) => require(['@/views/publicity/teaching'], resolve),//教学教务服务
          meta:{
              title:''
          }
      }, 
      {
          path: 'technologyService',
          name: 'technologyService',
          component: (resolve) => require(['@/views/publicity/technology'], resolve),//技术研发服务
          meta:{
              title:''
          }
      }, 
      {
        path: 'academicService',
        name: 'academicService',
        component: (resolve) => require(['@/views/publicity/academic'], resolve),//学术产品服务
        meta:{
            title:''
        }
      }, 
      {
        path: 'mshengIntroduct',
        name: 'mshengIntroduct',
        component: (resolve) => require(['@/views/publicity/introduct'], resolve),//民生在线简介
        meta:{
            title:''
        }
      },                      
      {
          path: 'apply',
          name: 'apply',
          component: (resolve) => require(['@/views/applyVIP/index'], resolve),//申请VIP跳转
          meta:{
              title:''
          }
      },    
      {
        path: 'customGuide',
        name: 'customGuide',
        component: (resolve) => require(['@/views/customGuide'], resolve),//定制版下载引导页
        meta:{
            title:''
        }
      },          
      ]
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js